import { IMatrixClient, MatrixRoomInfo } from "./matrixClient";

/**
 * Role-aware room listing.
 *
 * Backend authz (PR #109): GET matrix/rooms and GET matrix/private_chats are
 * super-admin-only. Club-scoped roles must use matrix/club/{id}/club_chats,
 * and a private-chats failure must never wipe the community chat list.
 */

export interface RoomListingViewer {
	isSuperAdmin: boolean;
	clubId?: string | null;
}

export interface ClubPageChats {
	communityChats: MatrixRoomInfo[];
	privateChats: MatrixRoomInfo[];
}

export async function loadClubPageChats(
	client: Pick<IMatrixClient, "getClubChats" | "getPrivateChats">,
	clubId: string,
	viewer: RoomListingViewer
): Promise<ClubPageChats> {
	const [community, priv] = await Promise.allSettled([
		client.getClubChats(clubId),
		viewer.isSuperAdmin
			? client.getPrivateChats()
			: Promise.resolve([] as MatrixRoomInfo[]),
	]);
	if (community.status === "rejected") {
		console.log("Matrix club chats error:", community.reason);
	}
	if (priv.status === "rejected") {
		console.log("Matrix private chats error:", priv.reason);
	}
	return {
		communityChats: community.status === "fulfilled" ? community.value : [],
		privateChats: priv.status === "fulfilled" ? priv.value : [],
	};
}

export async function getVisibleRooms(
	client: Pick<IMatrixClient, "getJoinedRooms" | "getClubChats">,
	viewer: RoomListingViewer
): Promise<MatrixRoomInfo[]> {
	if (viewer.isSuperAdmin) {
		return client.getJoinedRooms();
	}
	if (!viewer.clubId) {
		return [];
	}
	return client.getClubChats(viewer.clubId);
}
